import {TransactionEditor} from "./CreateQuotation.jsx";
export default function CreateSubscription(props){return <TransactionEditor {...props} kind="subscription"/>;}
